module.exports = __webpack_public_path__ + "img/1.444a5c7b.png";